/* eslint-disable no-useless-escape */
export const AUTH_CODE_MASK = '9 9 9 9 9 9'

export const PHONE_MASK = '55 (99) 99999-9999'

export const CPF_MASK = '999.999.999-99'

export const CPF_REGEX_VALIDATE = /[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}/

export const CNPJ_MASK = '99.999.999/9999-99'

export const CNPJ_REGEX_VALIDATE =
  /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2})$/

export const EMAIL_VALIDATE =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
